import React, { Component } from 'react';
import HowToLayout from './HowToLayout';

class HowToFriends extends Component {
    render() {
        return (
            <HowToLayout title="Friends">
                <p className="howto-intro">
                    Friends are the people you connect with on AniMates. Becoming friends is a two-way thing — you send a request, and the other person accepts. The <strong className="howto-strong">Friends</strong> tab is where you manage requests and your friends list.
                </p>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Your Friends List Is Private</h3>
                    <p className="howto-paragraph">
                        Your friends list is yours alone. Other members can never see who you're friends with — there's no setting to switch on, because your list is simply never shared.
                    </p>
                    <p className="howto-paragraph">
                        The only thing anyone else sees is your <strong className="howto-strong">friend count</strong> — the number on your community profile. Who those friends are stays private.
                    </p>
                    <p className="howto-paragraph">
                        Pending requests are private in both directions. Other members can't see who you've sent a request to, and they can't see who has requested you — the only people who know about a request are you and the person on the other end.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Adding a Friend</h3>
                    <p className="howto-paragraph">
                        Open someone's profile — for example, by tapping their photo from an event in the Community — and tap <strong className="howto-strong">Add Friend</strong>. The button changes to <strong className="howto-strong">Request Sent</strong> while you wait. Once they accept, it shows <strong className="howto-strong">Friends</strong> and you're connected.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Accepting a Request</h3>
                    <p className="howto-paragraph">
                        Incoming requests show up under the <strong className="howto-strong">Received</strong> tab in your Friends area, and a red dot appears on the tab when you have new ones. Open it, look over the person's profile, then tap <strong className="howto-strong">Accept</strong> to become friends or <strong className="howto-strong">Decline</strong> to pass. Declining doesn't notify them.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Checking Requests You've Sent</h3>
                    <p className="howto-paragraph">
                        The <strong className="howto-strong">Sent</strong> tab lists requests still waiting on a reply. If you change your mind before they respond, tap <strong className="howto-strong">Cancel</strong> to take the request back.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Removing a Friend</h3>
                    <p className="howto-paragraph">
                        In your friends list, tap <strong className="howto-strong">Unfriend</strong> on anyone you'd like to remove, then confirm. They're taken off your list right away.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Blocking Someone</h3>
                    <p className="howto-paragraph">
                        Open the person's profile, tap the <strong className="howto-strong">···</strong> menu in the top corner, and choose <strong className="howto-strong">Block</strong>. Blocking removes them and stops them from viewing your profile or contacting you. If you ever need a block undone, reach out to support.
                    </p>
                </section>

                <section className="howto-section">
                    <h3 className="howto-section-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Reporting Someone</h3>
                    <p className="howto-paragraph">
                        From that same <strong className="howto-strong">···</strong> menu, choose <strong className="howto-strong">Report</strong>. Pick a reason — Harassment, Abusive, Harmful, Cyberbullying, Location Settings, Privacy Settings, Copyright, Identity, or False Information — add a short description, and tap <strong className="howto-strong">Submit</strong>. Reports are confidential: the person isn't told who reported them, and they're added to your block list so you won't see them anymore. For urgent safety concerns, contact local authorities first.
                    </p>
                </section>

                <p className="howto-footer-note">
                    Still need a hand? Email <a href="mailto:hello@animates.app" className="howto-link">hello@animates.app</a>.
                </p>
            </HowToLayout>
        );
    }
}

export default HowToFriends;
